/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DevResponseMapStringObject,
} from '../models/index';
import {
    DevResponseMapStringObjectFromJSON,
    DevResponseMapStringObjectToJSON,
} from '../models/index';

export interface CreateDomainMappingRequest {
    requestBody: { [key: string]: any; };
}

export interface CreateTestCustomerAndDomainRequest {
    requestBody: { [key: string]: any; };
}

export interface CreateTestCustomerDomainDataRequest {
    requestBody: { [key: string]: any; };
}

export interface CreateTestTenantsRequest {
    count?: number;
}

export interface DebugDomainMappingRLSRequest {
    requestBody: { [key: string]: any; };
}

export interface DebugPermissionCalculationRequest {
    requestBody: { [key: string]: any; };
}

export interface DebugRlsContextRequest {
    sessionId?: string;
}

export interface DebugSessionCreationRLSRequest {
    requestBody: { [key: string]: any; };
}

export interface DebugUserCustomerRelationshipRequest {
    requestBody: { [key: string]: any; };
}

export interface SimulateFrontendCustomerCallRequest {
    requestBody: { [key: string]: any; };
}

export interface SimulateFrontendCustomerDomainCallRequest {
    requestBody: { [key: string]: any; };
}

export interface TestCaseEndpointsWithDynamicAdminRequest {
    requestBody: { [key: string]: any; };
}

export interface TestComprehensiveSessionCreationRequest {
    requestBody: { [key: string]: any; };
}

export interface TestCrossTenantAccessRequest {
    sourceTenant: string;
    targetTenant: string;
}

export interface TestCustomerDomainsBypassAdminRequest {
    requestBody: { [key: string]: any; };
}

export interface TestCustomerDomainsComprehensiveRequest {
    requestBody: { [key: string]: any; };
}

export interface TestCustomerDomainsDirectServiceRequest {
    requestBody: { [key: string]: any; };
}

export interface TestCustomerDomainsWithDynamicAdminRequest {
    requestBody: { [key: string]: any; };
}

export interface TestCustomerSecurityRequest {
    requestBody: { [key: string]: any; };
}

export interface TestDomainMappingCreationRequest {
    requestBody: { [key: string]: any; };
}

export interface TestDomainMappingRLSPolicyRequest {
    requestBody: { [key: string]: any; };
}

export interface TestNewCustomerDomainSecurityModelRequest {
    requestBody: { [key: string]: any; };
}

export interface TestPermissionsRequest {
    sessionId?: string;
}

export interface TestRLSPerformanceImpactRequest {
    requestBody: { [key: string]: number; };
}

export interface TestSessionContextSwitchRequest {
    requestBody: { [key: string]: string; };
}

export interface TestSessionCreationRequest {
    requestBody: { [key: string]: any; };
}

export interface TestSessionInfoRequest {
    sessionId?: string;
}

export interface TestSessionRetrievalFrontendSimulationRequest {
    requestBody: { [key: string]: any; };
}

export interface TestTenantCleanupVerificationRequest {
    tenantId: string;
}

export interface TestTenantEnrollmentComprehensiveRequest {
    requestBody: { [key: string]: any; };
}

export interface TestTenantSecurityRequest {
    requestBody: { [key: string]: any; };
}

export interface VerifyCustomerAccessRequest {
    userId: string;
    tenantId: string;
}

/**
 * DevTestControllerApi - interface
 * 
 * @export
 * @interface DevTestControllerApiInterface
 */
export interface DevTestControllerApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    bootstrapSystemEntitiesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     */
    bootstrapSystemEntities(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    checkComprehensiveTenantIsolationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     */
    checkComprehensiveTenantIsolation(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    checkRLSStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     */
    checkRLSStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    cleanupTestDataRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     */
    cleanupTestData(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * Clear all sessions from Redis cache to force new session creation
     * @summary Clear Redis session cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    clearSessionCacheRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     * Clear all sessions from Redis cache to force new session creation
     * Clear Redis session cache
     */
    clearSessionCache(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * Creates a domain mapping for testing session creation with specific domains
     * @summary Create domain mapping for testing
     * @param {{ [key: string]: any; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    createDomainMappingRaw(requestParameters: CreateDomainMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     * Creates a domain mapping for testing session creation with specific domains
     * Create domain mapping for testing
     */
    createDomainMapping(requestParameters: CreateDomainMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * Create a test customer and domain mapping for comprehensive testing
     * @summary Create test customer and domain for testing
     * @param {{ [key: string]: any; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    createTestCustomerAndDomainRaw(requestParameters: CreateTestCustomerAndDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     * Create a test customer and domain mapping for comprehensive testing
     * Create test customer and domain for testing
     */
    createTestCustomerAndDomain(requestParameters: CreateTestCustomerAndDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * Create test customer and domain mapping data for testing
     * @summary Create test customer domain data
     * @param {{ [key: string]: any; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    createTestCustomerDomainDataRaw(requestParameters: CreateTestCustomerDomainDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     * Create test customer and domain mapping data for testing
     * Create test customer domain data
     */
    createTestCustomerDomainData(requestParameters: CreateTestCustomerDomainDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * 
     * @param {number} [count] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    createTestTenantsRaw(requestParameters: CreateTestTenantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     */
    createTestTenants(requestParameters: CreateTestTenantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * Debug the admin tenant configuration and validation
     * @summary Debug admin tenant configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    debugAdminTenantConfigRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     * Debug the admin tenant configuration and validation
     * Debug admin tenant configuration
     */
    debugAdminTenantConfig(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * Debug the domain mapping RLS policy to understand why it\'s blocking
     * @summary Debug domain mapping RLS policy
     * @param {{ [key: string]: any; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    debugDomainMappingRLSRaw(requestParameters: DebugDomainMappingRLSRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     * Debug the domain mapping RLS policy to understand why it\'s blocking
     * Debug domain mapping RLS policy
     */
    debugDomainMappingRLS(requestParameters: DebugDomainMappingRLSRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * Debug permission calculation issues during session creation
     * @summary Debug permission calculation
     * @param {{ [key: string]: any; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    debugPermissionCalculationRaw(requestParameters: DebugPermissionCalculationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     * Debug permission calculation issues during session creation
     * Debug permission calculation
     */
    debugPermissionCalculation(requestParameters: DebugPermissionCalculationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * Check current RLS context settings and user provisioning
     * @summary Debug RLS context
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    debugRlsContextRaw(requestParameters: DebugRlsContextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     * Check current RLS context settings and user provisioning
     * Debug RLS context
     */
    debugRlsContext(requestParameters: DebugRlsContextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * 
     * @param {{ [key: string]: any; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    debugSessionCreationRLSRaw(requestParameters: DebugSessionCreationRLSRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     */
    debugSessionCreationRLS(requestParameters: DebugSessionCreationRLSRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * Debug how users are related to customers through tenants and permissions
     * @summary Debug user-customer relationships
     * @param {{ [key: string]: any; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    debugUserCustomerRelationshipRaw(requestParameters: DebugUserCustomerRelationshipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     * Debug how users are related to customers through tenants and permissions
     * Debug user-customer relationships
     */
    debugUserCustomerRelationship(requestParameters: DebugUserCustomerRelationshipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    getTenantContextRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     */
    getTenantContext(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    healthRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     */
    health(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * Debug endpoint to list all sessions in the database
     * @summary List all sessions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    listAllSessionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     * Debug endpoint to list all sessions in the database
     * List all sessions
     */
    listAllSessions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * Debug endpoint to see all users that exist in the database
     * @summary List all users in database
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    listAllUsersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     * Debug endpoint to see all users that exist in the database
     * List all users in database
     */
    listAllUsers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    refreshPermissionCacheRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     */
    refreshPermissionCache(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * Simulate the exact customer API call that the frontend is making to diagnose 403 errors
     * @summary Simulate frontend customer API call
     * @param {{ [key: string]: any; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    simulateFrontendCustomerCallRaw(requestParameters: SimulateFrontendCustomerCallRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     * Simulate the exact customer API call that the frontend is making to diagnose 403 errors
     * Simulate frontend customer API call
     */
    simulateFrontendCustomerCall(requestParameters: SimulateFrontendCustomerCallRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * Simulate the exact API call the frontend is making to diagnose 403 errors
     * @summary Simulate frontend customer domain call
     * @param {{ [key: string]: any; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    simulateFrontendCustomerDomainCallRaw(requestParameters: SimulateFrontendCustomerDomainCallRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     * Simulate the exact API call the frontend is making to diagnose 403 errors
     * Simulate frontend customer domain call
     */
    simulateFrontendCustomerDomainCall(requestParameters: SimulateFrontendCustomerDomainCallRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    testAllTableIsolationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     */
    testAllTableIsolation(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * Dynamically find admin user and tenant, create session, and test case retrieval and metrics endpoints
     * @summary Dynamic admin user case endpoints test
     * @param {{ [key: string]: any; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    testCaseEndpointsWithDynamicAdminRaw(requestParameters: TestCaseEndpointsWithDynamicAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     * Dynamically find admin user and tenant, create session, and test case retrieval and metrics endpoints
     * Dynamic admin user case endpoints test
     */
    testCaseEndpointsWithDynamicAdmin(requestParameters: TestCaseEndpointsWithDynamicAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * 
     * @param {{ [key: string]: any; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    testComprehensiveSessionCreationRaw(requestParameters: TestComprehensiveSessionCreationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     */
    testComprehensiveSessionCreation(requestParameters: TestComprehensiveSessionCreationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * 
     * @param {string} sourceTenant 
     * @param {string} targetTenant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    testCrossTenantAccessRaw(requestParameters: TestCrossTenantAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     */
    testCrossTenantAccess(requestParameters: TestCrossTenantAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * Test customer domain retrieval using system authentication to bypass admin tenant requirement
     * @summary Test customer domains bypassing admin requirement
     * @param {{ [key: string]: any; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    testCustomerDomainsBypassAdminRaw(requestParameters: TestCustomerDomainsBypassAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     * Test customer domain retrieval using system authentication to bypass admin tenant requirement
     * Test customer domains bypassing admin requirement
     */
    testCustomerDomainsBypassAdmin(requestParameters: TestCustomerDomainsBypassAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * Test customer domain retrieval with different authentication scenarios
     * @summary Comprehensive customer domain testing
     * @param {{ [key: string]: any; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    testCustomerDomainsComprehensiveRaw(requestParameters: TestCustomerDomainsComprehensiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     * Test customer domain retrieval with different authentication scenarios
     * Comprehensive customer domain testing
     */
    testCustomerDomainsComprehensive(requestParameters: TestCustomerDomainsComprehensiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * Test the customer domain service directly with system authentication to bypass JWT requirements
     * @summary Direct service test bypassing authentication
     * @param {{ [key: string]: any; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    testCustomerDomainsDirectServiceRaw(requestParameters: TestCustomerDomainsDirectServiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     * Test the customer domain service directly with system authentication to bypass JWT requirements
     * Direct service test bypassing authentication
     */
    testCustomerDomainsDirectService(requestParameters: TestCustomerDomainsDirectServiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * Dynamically find admin user and tenant, create session, and test customer domain endpoint
     * @summary Dynamic admin user customer domain test
     * @param {{ [key: string]: any; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    testCustomerDomainsWithDynamicAdminRaw(requestParameters: TestCustomerDomainsWithDynamicAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     * Dynamically find admin user and tenant, create session, and test customer domain endpoint
     * Dynamic admin user customer domain test
     */
    testCustomerDomainsWithDynamicAdmin(requestParameters: TestCustomerDomainsWithDynamicAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * Test customer retrieval with different user contexts and verify security rules
     * @summary Comprehensive customer security testing
     * @param {{ [key: string]: any; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    testCustomerSecurityRaw(requestParameters: TestCustomerSecurityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     * Test customer retrieval with different user contexts and verify security rules
     * Comprehensive customer security testing
     */
    testCustomerSecurity(requestParameters: TestCustomerSecurityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    testCustomerSecurityPerformanceRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     */
    testCustomerSecurityPerformance(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * Test domain mapping creation with system authentication to verify RLS policies work correctly
     * @summary Test domain mapping creation
     * @param {{ [key: string]: any; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    testDomainMappingCreationRaw(requestParameters: TestDomainMappingCreationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     * Test domain mapping creation with system authentication to verify RLS policies work correctly
     * Test domain mapping creation
     */
    testDomainMappingCreation(requestParameters: TestDomainMappingCreationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * Test that domain mapping RLS policy allows system operations during tenant enrollment
     * @summary Test domain mapping RLS policy
     * @param {{ [key: string]: any; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    testDomainMappingRLSPolicyRaw(requestParameters: TestDomainMappingRLSPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     * Test that domain mapping RLS policy allows system operations during tenant enrollment
     * Test domain mapping RLS policy
     */
    testDomainMappingRLSPolicy(requestParameters: TestDomainMappingRLSPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    testGroupBasedAccessRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     */
    testGroupBasedAccess(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * Test the improved customer domain security model based on RBAC and customer access control
     * @summary Test new customer domain security model
     * @param {{ [key: string]: any; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    testNewCustomerDomainSecurityModelRaw(requestParameters: TestNewCustomerDomainSecurityModelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     * Test the improved customer domain security model based on RBAC and customer access control
     * Test new customer domain security model
     */
    testNewCustomerDomainSecurityModel(requestParameters: TestNewCustomerDomainSecurityModelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    testPermissionsRaw(requestParameters: TestPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     */
    testPermissions(requestParameters: TestPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    testRLSComprehensiveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     */
    testRLSComprehensive(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * 
     * @param {{ [key: string]: number; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    testRLSPerformanceImpactRaw(requestParameters: TestRLSPerformanceImpactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     */
    testRLSPerformanceImpact(requestParameters: TestRLSPerformanceImpactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * 
     * @param {{ [key: string]: string; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    testSessionContextSwitchRaw(requestParameters: TestSessionContextSwitchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     */
    testSessionContextSwitch(requestParameters: TestSessionContextSwitchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * 
     * @param {{ [key: string]: any; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    testSessionCreationRaw(requestParameters: TestSessionCreationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     */
    testSessionCreation(requestParameters: TestSessionCreationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    testSessionInfoRaw(requestParameters: TestSessionInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     */
    testSessionInfo(requestParameters: TestSessionInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * Test session retrieval for admin@system.local user simulating frontend API calls
     * @summary Test session retrieval like frontend
     * @param {{ [key: string]: any; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    testSessionRetrievalFrontendSimulationRaw(requestParameters: TestSessionRetrievalFrontendSimulationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     * Test session retrieval for admin@system.local user simulating frontend API calls
     * Test session retrieval like frontend
     */
    testSessionRetrievalFrontendSimulation(requestParameters: TestSessionRetrievalFrontendSimulationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * 
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    testTenantCleanupVerificationRaw(requestParameters: TestTenantCleanupVerificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     */
    testTenantCleanupVerification(requestParameters: TestTenantCleanupVerificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * Test the complete tenant enrollment process including domain mapping creation
     * @summary Comprehensive tenant enrollment test
     * @param {{ [key: string]: any; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    testTenantEnrollmentComprehensiveRaw(requestParameters: TestTenantEnrollmentComprehensiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     * Test the complete tenant enrollment process including domain mapping creation
     * Comprehensive tenant enrollment test
     */
    testTenantEnrollmentComprehensive(requestParameters: TestTenantEnrollmentComprehensiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * Test tenant retrieval with different user contexts and verify RLS policies
     * @summary Comprehensive tenant security testing
     * @param {{ [key: string]: any; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    testTenantSecurityRaw(requestParameters: TestTenantSecurityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     * Test tenant retrieval with different user contexts and verify RLS policies
     * Comprehensive tenant security testing
     */
    testTenantSecurity(requestParameters: TestTenantSecurityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    testUserCreationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     */
    testUserCreation(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

    /**
     * 
     * @param {string} userId 
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevTestControllerApiInterface
     */
    verifyCustomerAccessRaw(requestParameters: VerifyCustomerAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>>;

    /**
     */
    verifyCustomerAccess(requestParameters: VerifyCustomerAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject>;

}

/**
 * 
 */
export class DevTestControllerApi extends runtime.BaseAPI implements DevTestControllerApiInterface {

    /**
     */
    async bootstrapSystemEntitiesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/dev/bootstrap/system`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     */
    async bootstrapSystemEntities(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.bootstrapSystemEntitiesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async checkComprehensiveTenantIsolationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/dev/database/comprehensive-tenant-isolation`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     */
    async checkComprehensiveTenantIsolation(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.checkComprehensiveTenantIsolationRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async checkRLSStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/dev/database/rls-status`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     */
    async checkRLSStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.checkRLSStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async cleanupTestDataRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/dev/test-data/cleanup`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     */
    async cleanupTestData(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.cleanupTestDataRaw(initOverrides);
        return await response.value();
    }

    /**
     * Clear all sessions from Redis cache to force new session creation
     * Clear Redis session cache
     */
    async clearSessionCacheRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/dev/clear-session-cache`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     * Clear all sessions from Redis cache to force new session creation
     * Clear Redis session cache
     */
    async clearSessionCache(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.clearSessionCacheRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates a domain mapping for testing session creation with specific domains
     * Create domain mapping for testing
     */
    async createDomainMappingRaw(requestParameters: CreateDomainMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling createDomainMapping().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/dev/create-domain-mapping`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     * Creates a domain mapping for testing session creation with specific domains
     * Create domain mapping for testing
     */
    async createDomainMapping(requestParameters: CreateDomainMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.createDomainMappingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a test customer and domain mapping for comprehensive testing
     * Create test customer and domain for testing
     */
    async createTestCustomerAndDomainRaw(requestParameters: CreateTestCustomerAndDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling createTestCustomerAndDomain().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/dev/test-customer-domains/create-test-customer-and-domain`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     * Create a test customer and domain mapping for comprehensive testing
     * Create test customer and domain for testing
     */
    async createTestCustomerAndDomain(requestParameters: CreateTestCustomerAndDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.createTestCustomerAndDomainRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create test customer and domain mapping data for testing
     * Create test customer domain data
     */
    async createTestCustomerDomainDataRaw(requestParameters: CreateTestCustomerDomainDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling createTestCustomerDomainData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/dev/test-customer-domains/create-test-data`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     * Create test customer and domain mapping data for testing
     * Create test customer domain data
     */
    async createTestCustomerDomainData(requestParameters: CreateTestCustomerDomainDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.createTestCustomerDomainDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createTestTenantsRaw(requestParameters: CreateTestTenantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        const queryParameters: any = {};

        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/dev/test-data/tenants`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     */
    async createTestTenants(requestParameters: CreateTestTenantsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.createTestTenantsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Debug the admin tenant configuration and validation
     * Debug admin tenant configuration
     */
    async debugAdminTenantConfigRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/dev/test-customer-domains/debug-admin-tenant-config`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     * Debug the admin tenant configuration and validation
     * Debug admin tenant configuration
     */
    async debugAdminTenantConfig(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.debugAdminTenantConfigRaw(initOverrides);
        return await response.value();
    }

    /**
     * Debug the domain mapping RLS policy to understand why it\'s blocking
     * Debug domain mapping RLS policy
     */
    async debugDomainMappingRLSRaw(requestParameters: DebugDomainMappingRLSRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling debugDomainMappingRLS().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/dev/test-domain-mapping/debug-rls`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     * Debug the domain mapping RLS policy to understand why it\'s blocking
     * Debug domain mapping RLS policy
     */
    async debugDomainMappingRLS(requestParameters: DebugDomainMappingRLSRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.debugDomainMappingRLSRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Debug permission calculation issues during session creation
     * Debug permission calculation
     */
    async debugPermissionCalculationRaw(requestParameters: DebugPermissionCalculationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling debugPermissionCalculation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/dev/debug-permission-calculation`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     * Debug permission calculation issues during session creation
     * Debug permission calculation
     */
    async debugPermissionCalculation(requestParameters: DebugPermissionCalculationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.debugPermissionCalculationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check current RLS context settings and user provisioning
     * Debug RLS context
     */
    async debugRlsContextRaw(requestParameters: DebugRlsContextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/dev/debug/rls-context`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     * Check current RLS context settings and user provisioning
     * Debug RLS context
     */
    async debugRlsContext(requestParameters: DebugRlsContextRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.debugRlsContextRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async debugSessionCreationRLSRaw(requestParameters: DebugSessionCreationRLSRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling debugSessionCreationRLS().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/dev/debug/session-creation-rls`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     */
    async debugSessionCreationRLS(requestParameters: DebugSessionCreationRLSRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.debugSessionCreationRLSRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Debug how users are related to customers through tenants and permissions
     * Debug user-customer relationships
     */
    async debugUserCustomerRelationshipRaw(requestParameters: DebugUserCustomerRelationshipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling debugUserCustomerRelationship().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/dev/test-customer-security/debug-user-customer-relationship`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     * Debug how users are related to customers through tenants and permissions
     * Debug user-customer relationships
     */
    async debugUserCustomerRelationship(requestParameters: DebugUserCustomerRelationshipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.debugUserCustomerRelationshipRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTenantContextRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/dev/tenant-context`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     */
    async getTenantContext(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.getTenantContextRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async healthRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/dev/health`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     */
    async health(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.healthRaw(initOverrides);
        return await response.value();
    }

    /**
     * Debug endpoint to list all sessions in the database
     * List all sessions
     */
    async listAllSessionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/dev/debug/list-all-sessions`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     * Debug endpoint to list all sessions in the database
     * List all sessions
     */
    async listAllSessions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.listAllSessionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Debug endpoint to see all users that exist in the database
     * List all users in database
     */
    async listAllUsersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/dev/debug/list-all-users`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     * Debug endpoint to see all users that exist in the database
     * List all users in database
     */
    async listAllUsers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.listAllUsersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async refreshPermissionCacheRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/dev/database/refresh-permission-cache`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     */
    async refreshPermissionCache(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.refreshPermissionCacheRaw(initOverrides);
        return await response.value();
    }

    /**
     * Simulate the exact customer API call that the frontend is making to diagnose 403 errors
     * Simulate frontend customer API call
     */
    async simulateFrontendCustomerCallRaw(requestParameters: SimulateFrontendCustomerCallRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling simulateFrontendCustomerCall().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/dev/test-customer-security/simulate-frontend-call`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     * Simulate the exact customer API call that the frontend is making to diagnose 403 errors
     * Simulate frontend customer API call
     */
    async simulateFrontendCustomerCall(requestParameters: SimulateFrontendCustomerCallRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.simulateFrontendCustomerCallRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Simulate the exact API call the frontend is making to diagnose 403 errors
     * Simulate frontend customer domain call
     */
    async simulateFrontendCustomerDomainCallRaw(requestParameters: SimulateFrontendCustomerDomainCallRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling simulateFrontendCustomerDomainCall().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/dev/test-customer-domains/simulate-frontend-call`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     * Simulate the exact API call the frontend is making to diagnose 403 errors
     * Simulate frontend customer domain call
     */
    async simulateFrontendCustomerDomainCall(requestParameters: SimulateFrontendCustomerDomainCallRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.simulateFrontendCustomerDomainCallRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async testAllTableIsolationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/dev/database/test-all-table-isolation`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     */
    async testAllTableIsolation(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.testAllTableIsolationRaw(initOverrides);
        return await response.value();
    }

    /**
     * Dynamically find admin user and tenant, create session, and test case retrieval and metrics endpoints
     * Dynamic admin user case endpoints test
     */
    async testCaseEndpointsWithDynamicAdminRaw(requestParameters: TestCaseEndpointsWithDynamicAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling testCaseEndpointsWithDynamicAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/dev/test-case-endpoints/dynamic-admin-test`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     * Dynamically find admin user and tenant, create session, and test case retrieval and metrics endpoints
     * Dynamic admin user case endpoints test
     */
    async testCaseEndpointsWithDynamicAdmin(requestParameters: TestCaseEndpointsWithDynamicAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.testCaseEndpointsWithDynamicAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async testComprehensiveSessionCreationRaw(requestParameters: TestComprehensiveSessionCreationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling testComprehensiveSessionCreation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/dev/test-comprehensive-session-creation`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     */
    async testComprehensiveSessionCreation(requestParameters: TestComprehensiveSessionCreationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.testComprehensiveSessionCreationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async testCrossTenantAccessRaw(requestParameters: TestCrossTenantAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        if (requestParameters['sourceTenant'] == null) {
            throw new runtime.RequiredError(
                'sourceTenant',
                'Required parameter "sourceTenant" was null or undefined when calling testCrossTenantAccess().'
            );
        }

        if (requestParameters['targetTenant'] == null) {
            throw new runtime.RequiredError(
                'targetTenant',
                'Required parameter "targetTenant" was null or undefined when calling testCrossTenantAccess().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sourceTenant'] != null) {
            queryParameters['sourceTenant'] = requestParameters['sourceTenant'];
        }

        if (requestParameters['targetTenant'] != null) {
            queryParameters['targetTenant'] = requestParameters['targetTenant'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/dev/test-isolation/cross-tenant-access`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     */
    async testCrossTenantAccess(requestParameters: TestCrossTenantAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.testCrossTenantAccessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Test customer domain retrieval using system authentication to bypass admin tenant requirement
     * Test customer domains bypassing admin requirement
     */
    async testCustomerDomainsBypassAdminRaw(requestParameters: TestCustomerDomainsBypassAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling testCustomerDomainsBypassAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/dev/test-customer-domains/bypass-admin-requirement`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     * Test customer domain retrieval using system authentication to bypass admin tenant requirement
     * Test customer domains bypassing admin requirement
     */
    async testCustomerDomainsBypassAdmin(requestParameters: TestCustomerDomainsBypassAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.testCustomerDomainsBypassAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Test customer domain retrieval with different authentication scenarios
     * Comprehensive customer domain testing
     */
    async testCustomerDomainsComprehensiveRaw(requestParameters: TestCustomerDomainsComprehensiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling testCustomerDomainsComprehensive().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/dev/test-customer-domains/comprehensive`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     * Test customer domain retrieval with different authentication scenarios
     * Comprehensive customer domain testing
     */
    async testCustomerDomainsComprehensive(requestParameters: TestCustomerDomainsComprehensiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.testCustomerDomainsComprehensiveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Test the customer domain service directly with system authentication to bypass JWT requirements
     * Direct service test bypassing authentication
     */
    async testCustomerDomainsDirectServiceRaw(requestParameters: TestCustomerDomainsDirectServiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling testCustomerDomainsDirectService().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/dev/test-customer-domains/direct-service-test`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     * Test the customer domain service directly with system authentication to bypass JWT requirements
     * Direct service test bypassing authentication
     */
    async testCustomerDomainsDirectService(requestParameters: TestCustomerDomainsDirectServiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.testCustomerDomainsDirectServiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Dynamically find admin user and tenant, create session, and test customer domain endpoint
     * Dynamic admin user customer domain test
     */
    async testCustomerDomainsWithDynamicAdminRaw(requestParameters: TestCustomerDomainsWithDynamicAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling testCustomerDomainsWithDynamicAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/dev/test-customer-domains/dynamic-admin-test`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     * Dynamically find admin user and tenant, create session, and test customer domain endpoint
     * Dynamic admin user customer domain test
     */
    async testCustomerDomainsWithDynamicAdmin(requestParameters: TestCustomerDomainsWithDynamicAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.testCustomerDomainsWithDynamicAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Test customer retrieval with different user contexts and verify security rules
     * Comprehensive customer security testing
     */
    async testCustomerSecurityRaw(requestParameters: TestCustomerSecurityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling testCustomerSecurity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/dev/test-customer-security/comprehensive`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     * Test customer retrieval with different user contexts and verify security rules
     * Comprehensive customer security testing
     */
    async testCustomerSecurity(requestParameters: TestCustomerSecurityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.testCustomerSecurityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async testCustomerSecurityPerformanceRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/dev/performance/customer-security-test`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     */
    async testCustomerSecurityPerformance(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.testCustomerSecurityPerformanceRaw(initOverrides);
        return await response.value();
    }

    /**
     * Test domain mapping creation with system authentication to verify RLS policies work correctly
     * Test domain mapping creation
     */
    async testDomainMappingCreationRaw(requestParameters: TestDomainMappingCreationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling testDomainMappingCreation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/dev/test-domain-mapping/creation`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     * Test domain mapping creation with system authentication to verify RLS policies work correctly
     * Test domain mapping creation
     */
    async testDomainMappingCreation(requestParameters: TestDomainMappingCreationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.testDomainMappingCreationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Test that domain mapping RLS policy allows system operations during tenant enrollment
     * Test domain mapping RLS policy
     */
    async testDomainMappingRLSPolicyRaw(requestParameters: TestDomainMappingRLSPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling testDomainMappingRLSPolicy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/dev/test-domain-mapping/rls-policy`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     * Test that domain mapping RLS policy allows system operations during tenant enrollment
     * Test domain mapping RLS policy
     */
    async testDomainMappingRLSPolicy(requestParameters: TestDomainMappingRLSPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.testDomainMappingRLSPolicyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async testGroupBasedAccessRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/dev/test-security/group-based-access`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     */
    async testGroupBasedAccess(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.testGroupBasedAccessRaw(initOverrides);
        return await response.value();
    }

    /**
     * Test the improved customer domain security model based on RBAC and customer access control
     * Test new customer domain security model
     */
    async testNewCustomerDomainSecurityModelRaw(requestParameters: TestNewCustomerDomainSecurityModelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling testNewCustomerDomainSecurityModel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/dev/test-customer-domains/new-security-model`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     * Test the improved customer domain security model based on RBAC and customer access control
     * Test new customer domain security model
     */
    async testNewCustomerDomainSecurityModel(requestParameters: TestNewCustomerDomainSecurityModelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.testNewCustomerDomainSecurityModelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async testPermissionsRaw(requestParameters: TestPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/dev/test-permissions`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     */
    async testPermissions(requestParameters: TestPermissionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.testPermissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async testRLSComprehensiveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/dev/test-rls/comprehensive`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     */
    async testRLSComprehensive(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.testRLSComprehensiveRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async testRLSPerformanceImpactRaw(requestParameters: TestRLSPerformanceImpactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling testRLSPerformanceImpact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/dev/test-performance/rls-impact`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     */
    async testRLSPerformanceImpact(requestParameters: TestRLSPerformanceImpactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.testRLSPerformanceImpactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async testSessionContextSwitchRaw(requestParameters: TestSessionContextSwitchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling testSessionContextSwitch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/dev/test-isolation/session-context-switch`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     */
    async testSessionContextSwitch(requestParameters: TestSessionContextSwitchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.testSessionContextSwitchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async testSessionCreationRaw(requestParameters: TestSessionCreationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling testSessionCreation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/dev/test-session`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     */
    async testSessionCreation(requestParameters: TestSessionCreationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.testSessionCreationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async testSessionInfoRaw(requestParameters: TestSessionInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/dev/test-session-info`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     */
    async testSessionInfo(requestParameters: TestSessionInfoRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.testSessionInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Test session retrieval for admin@system.local user simulating frontend API calls
     * Test session retrieval like frontend
     */
    async testSessionRetrievalFrontendSimulationRaw(requestParameters: TestSessionRetrievalFrontendSimulationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling testSessionRetrievalFrontendSimulation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/dev/test-session-retrieval/frontend-simulation`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     * Test session retrieval for admin@system.local user simulating frontend API calls
     * Test session retrieval like frontend
     */
    async testSessionRetrievalFrontendSimulation(requestParameters: TestSessionRetrievalFrontendSimulationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.testSessionRetrievalFrontendSimulationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async testTenantCleanupVerificationRaw(requestParameters: TestTenantCleanupVerificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling testTenantCleanupVerification().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tenantId'] != null) {
            queryParameters['tenantId'] = requestParameters['tenantId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/dev/test-cleanup/verify-purge`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     */
    async testTenantCleanupVerification(requestParameters: TestTenantCleanupVerificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.testTenantCleanupVerificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Test the complete tenant enrollment process including domain mapping creation
     * Comprehensive tenant enrollment test
     */
    async testTenantEnrollmentComprehensiveRaw(requestParameters: TestTenantEnrollmentComprehensiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling testTenantEnrollmentComprehensive().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/dev/test-tenant-enrollment/comprehensive`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     * Test the complete tenant enrollment process including domain mapping creation
     * Comprehensive tenant enrollment test
     */
    async testTenantEnrollmentComprehensive(requestParameters: TestTenantEnrollmentComprehensiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.testTenantEnrollmentComprehensiveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Test tenant retrieval with different user contexts and verify RLS policies
     * Comprehensive tenant security testing
     */
    async testTenantSecurityRaw(requestParameters: TestTenantSecurityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling testTenantSecurity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/dev/test-tenant-security/comprehensive`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     * Test tenant retrieval with different user contexts and verify RLS policies
     * Comprehensive tenant security testing
     */
    async testTenantSecurity(requestParameters: TestTenantSecurityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.testTenantSecurityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async testUserCreationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/dev/test-user-creation`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     */
    async testUserCreation(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.testUserCreationRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async verifyCustomerAccessRaw(requestParameters: VerifyCustomerAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevResponseMapStringObject>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling verifyCustomerAccess().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling verifyCustomerAccess().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['tenantId'] != null) {
            queryParameters['tenantId'] = requestParameters['tenantId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/dev/test-security/verify-customer-access`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevResponseMapStringObjectFromJSON(jsonValue));
    }

    /**
     */
    async verifyCustomerAccess(requestParameters: VerifyCustomerAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevResponseMapStringObject> {
        const response = await this.verifyCustomerAccessRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
